import React, { Component } from 'react';
import ScrollableAnchor from 'react-scrollable-anchor'

import "./VideoMain.scss"
import dataJSON from "../../api/data.json"
import dropDown from "../../static/images/desktop/dropdown.gif"
class VideoMain extends Component {
  constructor() {
    super();
    this.isMobile = this.isMobile.bind(this);
    this.state = {
    }
  }
  isMobile() {
    if (navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      return true;
    } else {
      return false;
    }
  }
  componentDidMount() {
    var container = window.document.getElementById("player");
    window.flowplayer.conf.fullscreen = true;
    window.flowplayer((api, root) => {
      var fsbutton = root.querySelector(".fp-fullscreen");

      if (this.isMobile()) {
        container.addEventListener("click", () => {
          api.fullscreen();
        });
      }
      if (!this.isMobile()) {
        api.on("ready", function () {
          root.querySelector(".fp-controls").appendChild(fsbutton);
        });
      }
    });
    window.flowplayer(container, {
      key: '$858384515984319,$509034830680622,$968022418025930,$104200519403602,$955543217793552,$112133720880866,$508506330648762,$509034830680622,$664969740079151,$574051834599330,$617925037243662',
      autoplay: true,
      muted: true,
      analytics: "UA-5536870-34",
      fullscreen: true,
      native_fullscreen: true,
      ratio: 9 / 16,
      buffering: false,
      mouseoutTimeout: 1500,
      share: false,
      hlsjs: {
        maxMaxBufferLength: 60
      },
      cuepoints: [18.0, 47.0, 94.0, 141.0, 180.0],
      clip: {
        sources: [
          {
            type: "application/x-mpegurl",
            src: dataJSON.VideoMain.srcM3U8
          },
          {
            type: "video/mp4",
            src: dataJSON.VideoMain.src
          }
        ]
      }
    }).on("cuepoint", function (e, api, cuepoint) {
      switch (cuepoint.time) {
        case 18:
          var cup = "10%";
          break;
        case 47:
          var cup = "25%";
          break;
        case 94:
          var cup = "50%";
          break;
        case 141:
          var cup = "75%";
          break;
        case 180:
          var cup = "100%";
          break;
      }
      console.log(cuepoint.time + " " + cup);
      window.dataLayer.push({
        'event': 'GA_Event',
        'Category': 'Vaseline',
        'Action': 'Video_Duration',
        'Label': cup
      });
    });
  }
  render() {
    return (
      <section className="section section-video">
        <ScrollableAnchor id={`section1`}>
          <div className="container">
            <div id="player" className="flowplayer fp-full fixed-controls play-button fp-mute"></div>
            <div className="readmore">
              <div className="goDown">
                <div className="image">
                  <img src={dropDown} alt="" />
                </div>
              </div>
            </div>
          </div>
        </ScrollableAnchor>
      </section>
    );
  }
}

export default VideoMain;



// WEBPACK FOOTER //
// ./src/Components/VideoMain/VideoMain.js